import { useState } from "react";
import type { FaqItem } from "@/types/content";

export default function FaqAccordion({ items }: { items: readonly FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={item.question}
            className={`rounded-lg border bg-background-50 transition-colors ${
              isOpen ? "border-primary-300" : "border-background-200"
            }`}
          >
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-heading text-base font-bold text-foreground-950">
                  {item.question}
                </span>
                <span
                  className={`flex h-6 w-6 flex-none items-center justify-center rounded-full transition-colors ${
                    isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-5 pb-5">
                <p className="border-t border-background-200 pt-4 text-sm leading-relaxed text-foreground-600">
                  {item.answer}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}